import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { createTeraSync } from '@iebh/vuex-tera-json'

Vue.config.productionTip = false

// Bootstrap Vue
import './theme.scss'
import {
	BNavbar,
	BNavbarBrand,
	BNavbarNav,
	BButton,
	BTabs,
	BTab,
	BFormFile,
	BContainer,
	BModal,
	BCard,
	BCardHeader,
	BCardBody,
	BCollapse,
	VBToggle,
	BIconCaretRight,
	BIconCaretDown,
	BButtonToolbar,
	BButtonGroup,
	BDropdown,
	BDropdownItem,
	BDropdownDivider,
	BDropdownGroup,
	VBModal,
	BRow,
	BCol,
	BProgress,
	BProgressBar,
	BFormTextarea,
	BIconX,
	BFormGroup,
	BFormInput,
	BFormTags,
	BFormSelect,
	BFormCheckbox,
	BIconQuestionCircleFill,
	BIconPlus,
	BTooltip,
	BInputGroup,
} from '@iebh/bootstrap-vue';
// Navbar
Vue.component('b-navbar', BNavbar);
Vue.component('b-navbar-brand', BNavbarBrand);
Vue.component('b-navbar-nav', BNavbarNav);
// Button
Vue.component('b-button', BButton);
// File Upload
Vue.component('b-tabs', BTabs);
Vue.component('b-tab', BTab);
Vue.component('b-form-file', BFormFile);
Vue.component('b-container', BContainer);
// Warning modal
Vue.component('b-modal', BModal);
// Dupes
Vue.component('b-card', BCard);
Vue.component('b-card-header', BCardHeader);
Vue.component('b-card-body', BCardBody);
Vue.component('b-collapse', BCollapse);
Vue.directive('b-toggle', VBToggle );
Vue.component('BIconCaretRight', BIconCaretRight);
Vue.component('BIconCaretDown', BIconCaretDown);
Vue.component('BFormCheckbox', BFormCheckbox);
// Toolbar
Vue.component('b-button-toolbar', BButtonToolbar);
Vue.component('b-button-group', BButtonGroup);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-item', BDropdownItem);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('b-dropdown-group', BDropdownGroup);
Vue.directive('b-modal', VBModal );
Vue.component('b-row', BRow );
Vue.component('b-col', BCol );
// Progress
Vue.component('b-progress', BProgress );
Vue.component('b-progress-bar', BProgressBar );
// Edit Reference
Vue.component('b-form-textarea', BFormTextarea );
Vue.component('b-icon-x', BIconX );
Vue.component('b-form-group', BFormGroup );
Vue.component('b-form-input', BFormInput );
Vue.component('b-form-tags', BFormTags );
// Export
Vue.component('b-form-select', BFormSelect);
// Help Hover
Vue.component('b-icon-question-circle-fill', BIconQuestionCircleFill);
Vue.component('b-icon-plus', BIconPlus);
Vue.component('b-tooltip', BTooltip);
Vue.component('b-input-group', BInputGroup);
// Toast
import { ToastPlugin } from '@iebh/bootstrap-vue';
Vue.use(ToastPlugin);


// Import $tera / @iebh/Tera-fy global service
// NOTE: See bottom of file inside main async() init loop for when TeraFy actually boots
import TeraFy from '@iebh/tera-fy/dist/terafy.es2019.js'; // FIX: Use annoyingly old and specific version as Babel struggles with ESNEXT class imports
import TerafyVue from '@iebh/tera-fy/dist/plugin.vue2.es2019.js';

let terafy = new TeraFy()
	.set("devMode", process.env.VUE_APP_TERAFY_DEV)
	.setIfDev("verbosity", process.env.VUE_APP_TERAFY_VERBOSITY)
	.use(TerafyVue); // Add the Vue plugin

// --- TERA Sync Plugin Initialization ---
const teraSyncApi = createTeraSync(
	{
			keyPrefix: 'deduplicator',
			isSeparateStateForEachUser: false,
	},
	store
);
// Make the API accessible globally
Vue.prototype.$teraSync = teraSyncApi;
// --- End TERA Sync Plugin Initialization ---

// Boot Vue + Tera
(async () => {
	const app = new Vue({
		store,
		render: h => h(App),
		beforeDestroy() {
			// Cleanup
			if (teraSyncApi && typeof teraSyncApi.destroy === 'function') {
				console.log("Destroying TERA Sync Plugin");
				teraSyncApi.destroy();
			}
		}
	});

	// --- Set the Vue instance for the teraSyncApi ---
	if (teraSyncApi && typeof teraSyncApi.setVueInstance === 'function') {
		teraSyncApi.setVueInstance(app);
	} else {
		console.error("Failed to set Vue instance on TERA Sync API object.");
	}

	try {
		terafy.set({
			mode: 'parent', // Force parent mode
		});

		await terafy.init({
			app,
			Vue,
		});

		// --- Set TERA ready ---
		if (teraSyncApi && typeof teraSyncApi.setTeraReady === 'function') {
			console.log("Setting TERA Ready on Sync Plugin");
			await teraSyncApi.setTeraReady();
		} else {
			console.error("Failed to set TERA Ready on TERA Sync API object.");
		}
	} catch (error) {
		console.error("TeraFy initialization failed:", error);
	}

	app.$mount("#app");
})();
